//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components
import { Loading } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const LoadingComponent = () => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div className="fldoh-loading-group">
                <div className="fldoh-loading-group-item">
                    <Loading
                        className="fldoh-loading"
                        description="Active Loading Indicator"
                        withOverlay={false}
                        small={false}
                        role="alert"
                        aria-busy="true"
                        data-testid="loading-component"
                    />
                </div>
            </div>
        </>
    )
}

export default LoadingComponent
